<template>
  <div class="mt-2">
    <div class="d-flex">
      <button
        type="button"
        class="btn rounded-pill btn-sm btn-outline-primary text-left px-3 tw:truncate"
        v-on:click.prevent="onClickEdit()"
        :title="buttonTitle"
      >
        <strong>{{ name }}</strong> :
        <span v-if="criteria.type === 'variants'">
          <span v-show="state === 'initializing'">…</span>
          <span
            v-show="state === 'idle'"
            v-for="(activity, index) in value?.slice(0, 2)"
            class="ml-1"
            :key="activity.code"
          >
            <span>{{ activity.code }}</span>
            <span v-if="activity.variantsList" class="text-muted">
              ({{ activity.variantsList?.length }}/{{ activity.variantsTotal }})
            </span>
            <template v-if="value?.length >= (index + 1) && value?.length !== 2">, </template>
          </span>
          <span v-if="value?.length > 2">
              +{{ $t('activities', {count: (value.length - 2)}, (value.length - 2)) }}
          </span>
        </span>
        <span v-else>
          {{ value }}
        </span>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-link"
        v-on:click.prevent="deleteCriteria()"
      >
        <i class="fa fa-times text-danger"></i>
      </button>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

const props = defineProps({
  criteria: Object,
  availableSegments: Array,
  activities: Array,
  state: String,
});
const emit = defineEmits(['delete-criteria', 'edit-criteria']);

const segment = computed(() => {
  return props.criteria === null ? {} : props.criteria;
});

const segmentDetails = computed(() => {
  return props.availableSegments.find(
    (segmentItem) => segmentItem.type === segment.value.type,
  );
});

const name = computed(() => {
  return segmentDetails.value?.name;
});

const value = computed(() => {
  if (!segmentDetails.value) {
    return segment.value.value;
  }

  if (segmentDetails.value.type === 'extrafields') {
    const extrafieldOption = props.availableSegments
      .find((segmentItem) => segmentItem.type === 'extrafields')
      .options.find((option) => {
        return String(option.type) === String(segment.value.value.field);
      });

    const foundOption = extrafieldOption.options.find((option) => {
      return String(option.id) === String(segment.value.value.value);
    });

    return String(
      extrafieldOption.name + (foundOption ? ' : ' + foundOption.name : ''),
    );
  }

  if (segmentDetails.value.type === 'variants') {
    if (props.state === 'idle') {
      return props.activities.reduce(function (variants, activity) {
        let variantArr = activity.variants.filter(function (variant) {
          return props.criteria.value.includes(variant.id);
        });
        const data = {
          id: activity.id,
          code: activity.code,
          variantsList: variantArr,
          variantsTotal: activity.variants.length,
        };
        if (data.variantsList.length > 0) {
          variants.push(data);
        }
        return variants;
      }, []);
    }
  }
  if (segmentDetails.value.options.length > 0) {
    return segmentDetails.value.options.find((option) => {
      return String(option.id) === String(segment.value.value);
    })?.name;
  }
  return segment.value.value;
});

const buttonTitle = computed(() => {
  let title = name.value ? name.value + ' : ' : '';
  if (props.criteria.type === 'variants') {
    if (props.state === 'initializing') {
      title += '...';
    } else if (props.state === 'idle' && Array.isArray(value.value)) {
      const shown = value.value.slice(0, 2).map((activity) => {
        let str = activity.code;
        if (activity.variantsList) {
          str += ` (${activity.variantsList.length}/${activity.variantsTotal})`;
        }
        return str;
      });
      title += shown.join(', ');
      if (value.value.length > 2) {
        title += `, +${t('activities', (value.value.length - 2), {count: (value.value.length - 2)})}`
      }
    }
  } else {
    title += value.value;
  }
  return title;
});

function deleteCriteria() {
  emit('delete-criteria');
}
function onClickEdit() {
  emit('edit-criteria');
}
</script>
